import { render, staticRenderFns } from "./goodsSubmit.vue?vue&type=template&id=ffc41296&scoped=true"
import script from "./goodsSubmit.vue?vue&type=script&lang=js"
export * from "./goodsSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc41296",
  null
  
)

export default component.exports